import React, { useState } from 'react';
import { Route, Switch, Redirect, Link, NavLink } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faBullhorn, faList, faFileAlt, faHistory, faHome, faBars, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { Nav, Button } from '@themesberg/react-bootstrap';
import SidebarItem from '../../components/sidebar/SidebarItem';
import Navbar from '../../components/Navbar';
import SystemNotificationBanner from '../../components/SystemNotificationBanner';
import { NotificationProvider } from './context';
import { BASE, menus } from './model';
import Events from './Events';
import Campaigns from './Campaigns';
import Composer from './Composer';
import Report from './Report';
import Templates from './Templates';
import History from './History';
import TestStudio from './TestStudio';
import './notifications.css';

export default function NotificationManagement() {
  const [show, setShow] = useState(false);
  const icons = [faList, faBullhorn, faFileAlt, faHistory, faPaperPlane];
  return <NotificationProvider>
    <Button variant="primary" className="d-md-none m-3" aria-label="Mở menu thông báo" aria-expanded={show} onClick={() => setShow(!show)}><FontAwesomeIcon icon={faBars} /> Menu thông báo</Button>
    <SimpleBar className={`collapse ${show ? 'show' : ''} sidebar d-md-block bg-primary text-white`}>
      <div className="sidebar-inner px-4 pt-4"><h6 className="mb-4"><FontAwesomeIcon icon={faBell} className="me-2" />Quản lý thông báo</h6>
        <Nav className="flex-column"><SidebarItem title="Trang chủ" link="/" icon={faHome} setShow={setShow} />
          {menus.map(([key, label], index) => <SidebarItem key={key} title={label} link={`${BASE}/${key}`} icon={icons[index]} setShow={setShow} />)}
        </Nav>
      </div>
    </SimpleBar>
    <main className="content notification-management"><Navbar /><SystemNotificationBanner />
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 my-4"><div><div className="small text-muted">Quản trị / Thông báo khách hàng</div><h3 className="mb-0">Quản lý thông báo</h3></div>
        <Button as={Link} to={`${BASE}/campaigns/new`} variant="primary"><FontAwesomeIcon icon={faBullhorn} className="me-2" />Tạo chiến dịch</Button>
      </div>
      <Nav className="noti-tabs mb-4" aria-label="Các màn quản lý thông báo">{menus.map(([key, label]) => <Nav.Item key={key}><Nav.Link as={NavLink} activeClassName="noti-active" to={`${BASE}/${key}`}>{label}</Nav.Link></Nav.Item>)}</Nav>
      <Switch>
        <Route exact path={`${BASE}/events`} component={Events} />
        <Route exact path={`${BASE}/campaigns`} component={Campaigns} />
        <Route exact path={`${BASE}/campaigns/new`} component={Composer} />
        <Route exact path={`${BASE}/campaigns/:id/report`} component={Report} />
        <Route exact path={`${BASE}/campaigns/:id`} component={Composer} />
        <Route exact path={`${BASE}/templates`} component={Templates} />
        <Route exact path={`${BASE}/history`} component={History} />
        <Route exact path={`${BASE}/tests`} component={TestStudio} />
        <Redirect to={`${BASE}/events`} />
      </Switch>
    </main>
  </NotificationProvider>;
}
